import $ from 'jquery';
import _ from 'lodash';
import Backbone from 'backbone';
import { Storage, ErrorsModal, Preloader } from '../../../core/utils';

const
	error = {
		network: 'Oops, something went wrong! Please refresh the page and try again.'
	},
	onError = {
		401: () => {
			Storage.get('sid') && location.reload();
			Storage.remove('sid');
			Storage.remove('user');
			Backbone.history.loadUrl();
		},
		'*': (errors = error.network) => {
			Preloader.hide();
			ErrorsModal.show(errors);
		}
	},
	onNetworkErrorOnce = _.once(() => onError['*']());

$(document).ajaxSuccess(function(event, request) {
	const { errors } = request.responseJSON;

	if (_.size(errors)) {
		_.each(errors, ({ code }) => {
			const func = onError[code];

			if (_.isFunction(func)) {
				func(errors);
			}
		})
	}
});

$(document).ajaxError(onNetworkErrorOnce);